import { GraphQL } from '@guestgoodie/graphql'

import { useIsFeatureConnected } from './useIsFeatureConnected'

export function useIsPmsConnected() {
  return useIsFeatureConnected(GraphQL.IntegrationTypes.Pms)
}
